// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "2d19a7b2a1a583ec","923": "d5b33fbb92d6879b",}[chunkId] + ".css"
}